import { useNavigate } from 'react-router-dom';
import { Clock } from 'lucide-react';

export const TIMEOUT_PAGE_PATH = '/test/time-out';

const TestTimeOutPage = () => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center justify-center min-h-screen max-w-lg mx-auto bg-bg-main p-6 text-center">
      <Clock className="w-12 h-12 text-accent-purple mb-4" />
      <h1 className="text-2xl font-bold text-title mb-2">Time's up</h1>
      <p className="text-subheading mb-6">
        Your test time has run out. Your progress has been saved.
      </p>
      <button
        onClick={() => navigate('/courses')}
        className="bg-accent-purple text-white px-6 py-3 rounded-lg font-medium"
      >
        Back to Courses
      </button>
    </div>
  );
};

export default TestTimeOutPage;
